import {
  FlexibleConnectedPositionStrategy,
  FlexibleConnectedPositionStrategyOrigin,
  Overlay,
  OverlayContainer,
  OverlayRef,
  ViewportRuler,
} from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { ElementRef, inject, Injectable } from '@angular/core';

@Injectable()
export class TargetedOverlay extends Overlay {}

@Injectable()
export class TargetedOverlayContainer extends OverlayContainer {
  targetElement?: HTMLElement;
  protected override _createContainer(): void {
    if (!this.targetElement) {
      throw new Error('target element not provided');
    }
    this._containerElement = this.targetElement;
  }
}

export class RelativeFlexibleConnectedPositionStrategy extends FlexibleConnectedPositionStrategy {
  private marginPx = 0;
  private overlayRef?: OverlayRef;
  private containerRef?: ElementRef<HTMLElement>;

  override attach(overlayRef: OverlayRef): void {
    super.attach(overlayRef);
    this.overlayRef = overlayRef;
  }

  override apply(): void {
    super.apply();
    const element = this.overlayRef?.overlayElement;
    if (!element || !this.containerRef) {
      return;
    }
    const { x, y } = this.containerRef.nativeElement.getBoundingClientRect();
    const originalTop = parseInt(element.style.top) - y;
    const originalLeft = parseInt(element.style.left) - x;
    const top = Math.max(
      this.marginPx,
      Math.min(
        originalTop,
        this.containerRef.nativeElement.clientHeight - element.offsetHeight - this.marginPx,
      ),
    );
    const left = Math.max(
      this.marginPx,
      Math.min(
        originalLeft,
        this.containerRef.nativeElement.clientWidth - element.offsetWidth - this.marginPx,
      ),
    );
    element.style.top = `${top}px`;
    element.style.left = `${left}px`;
  }

  withContainerRef(
    containerRef: ElementRef<HTMLElement>,
  ): RelativeFlexibleConnectedPositionStrategy {
    this.containerRef = containerRef;
    return this;
  }

  withMarginPx(marginPx: number): RelativeFlexibleConnectedPositionStrategy {
    this.marginPx = marginPx;
    return this;
  }
}

@Injectable()
export class RelativeFlexibleConnectedPositionStrategyBuilder {
  private _viewportRuler = inject(ViewportRuler);
  private _document = inject(DOCUMENT);
  private _platform = inject(Platform);
  private _overlayContainer = inject(OverlayContainer);

  build(
    origin: FlexibleConnectedPositionStrategyOrigin,
  ): RelativeFlexibleConnectedPositionStrategy {
    return new RelativeFlexibleConnectedPositionStrategy(
      origin,
      this._viewportRuler,
      this._document,
      this._platform,
      this._overlayContainer,
    ).withFlexibleDimensions(false);
  }
}
